import { Route } from 'react-router-dom';
import type { ReactElement } from 'react';
import { TargetShell } from '../identity/TargetShell';
import { PrintQueueDashboardPage } from './dashboard/PrintQueuePage';
import { PrintQueueJobsPage } from './pages/Jobs';
import {
  PrintersRedirect,
  PrintQueuePrintServerPage,
  PrintQueuePrintServersPage,
} from './pages/PrintServers';
import { PrintQueuePrintServerLogsPage } from './pages/PrintServerLogs';
import { PrintQueueTokensPage } from './pages/Tokens';
import { PrintQueueTenantsPage } from './pages/Tenants';

/** Path → page; every page runs inside the environment shell (`?target=`, only environments with a print queue). */
const PAGES: [string, () => ReactElement][] = [
  ['/printqueue/jobs', () => <PrintQueueJobsPage />],
  ['/printqueue/printservers', () => <PrintQueuePrintServersPage />],
  ['/printqueue/printserver', () => <PrintQueuePrintServerPage />],
  ['/printqueue/printserver/logs', () => <PrintQueuePrintServerLogsPage />],
  ['/printqueue/tokens', () => <PrintQueueTokensPage />],
  ['/printqueue/tenants', () => <PrintQueueTenantsPage />],
];

/** The Print queue group's routes: the dashboard when the group may be opened, each page when its nav entry may be. */
export function printQueueRoutes(canOpenGroup: boolean, allowed: (path: string) => boolean) {
  const nav = (path: string) =>
    path.startsWith('/printqueue/printserver/') || path === '/printqueue/printserver'
      ? '/printqueue/printservers'
      : path;
  return [
    canOpenGroup && <Route key="/printqueue" path="/printqueue" element={<PrintQueueDashboardPage />} />,
    allowed('/printqueue/printservers') && (
      <Route key="/printqueue/printers" path="/printqueue/printers" element={<PrintersRedirect />} />
    ),
    ...PAGES.filter(([path]) => allowed(nav(path))).map(([path, page]) => (
      <Route key={path} path={path} element={<TargetShell service="printqueue">{page()}</TargetShell>} />
    )),
  ];
}
